module.exports = __webpack_public_path__ + "img/member_icon.0c60a08f.svg";